import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft overflow-hidden" }
const _hoisted_2 = { class: "p-4 border-b border-primary-100" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800" }, " Local Events ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" See all → ")
const _hoisted_6 = {
  key: 0,
  class: "p-4 space-y-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-12 bg-primary-100 rounded-lg flex-shrink-0" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-4 bg-primary-100 rounded w-3/4 mb-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-primary-50 rounded w-1/2" })
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "divide-y divide-primary-100"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-xs font-medium uppercase" }
const _hoisted_13 = { class: "text-lg font-bold leading-none" }
const _hoisted_14 = { class: "flex-1 min-w-0" }
const _hoisted_15 = { class: "flex items-start gap-2" }
const _hoisted_16 = { class: "font-medium text-primary-800 truncate" }
const _hoisted_17 = {
  key: 0,
  class: "flex-shrink-0 px-1.5 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded"
}
const _hoisted_18 = { class: "text-sm text-primary-500 truncate" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-300 flex-shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_21 = {
  key: 2,
  class: "p-8 text-center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-12 h-12 mx-auto text-primary-300 mb-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500" }, "No upcoming events", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-3 bg-primary-50 border-t border-primary-100" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://whitnallcommons.com",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "text-xs text-primary-400 hover:text-accent-600 flex items-center gap-1 transition-colors"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "w-3 h-3",
      fill: "currentColor",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z",
        "clip-rule": "evenodd"
      })
    ]),
    /*#__PURE__*/_createTextVNode(" Powered by Whitnall Commons ")
  ])
], -1)

import { ref, onMounted, computed } from "vue";
import { HoodApi } from "@/services/HoodApi";
import EventDetailModal from "@/components/events/EventDetailModal.vue";

interface LocalEvent {
  id: string | number;
  title: string;
  description?: string;
  date: string;
  time?: string;
  location: string;
  venue?: string;
  url?: string;
  image?: string;
  image_url?: string;
  type?: string;
  source_name?: string;
  isNeighborhood: boolean;
  monthShort: string;
  day: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(true);
const neighborhoodEvents = ref<any[]>([]);
const localEventsData = ref<any[]>([]);
const selectedEvent = ref<LocalEvent | null>(null);

// Parse date string as local time (not UTC)
const parseLocalDate = (dateStr: string | null | undefined) => {
  if (!dateStr) return new Date();
  return new Date(dateStr.replace(/-/g, "/"));
};

// Compute the next occurrence for recurring events based on recurring_day
const computeNextOccurrence = (
  recurringDay: string | null | undefined
): string | null => {
  if (!recurringDay) return null;

  const dayMap: Record<string, number> = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  const targetDay = dayMap[recurringDay.toLowerCase()];
  if (targetDay === undefined) return null;

  const today = new Date();
  const currentDay = today.getDay();

  let daysUntil = targetDay - currentDay;
  if (daysUntil < 0) {
    daysUntil += 7;
  }

  const nextDate = new Date(today);
  nextDate.setDate(today.getDate() + daysUntil);

  const year = nextDate.getFullYear();
  const month = String(nextDate.getMonth() + 1).padStart(2, "0");
  const day = String(nextDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const events = computed<LocalEvent[]>(() => {
  const combined: LocalEvent[] = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Start of today

  // Add neighborhood events (only upcoming)
  neighborhoodEvents.value.forEach((event) => {
    const date = parseLocalDate(event.starting_date);
    if (date >= today) {
      combined.push({
        id: `hoa-${event.id}`,
        title: event.title,
        description: event.description,
        date: event.starting_date,
        time: event.start_time ? formatTime(event.start_time) : undefined,
        location: "Foxwood Crossing",
        image: event.image,
        isNeighborhood: true,
        monthShort: date.toLocaleDateString("en-US", { month: "short" }),
        day: date.getDate(),
      });
    }
  });

  // Add local events from Whitnall Commons (only upcoming)
  localEventsData.value.forEach((event) => {
    // Determine event date - compute next occurrence for recurring events
    let eventDateStr = event.date;
    if (!eventDateStr && event.recurring && event.recurring_day) {
      eventDateStr = computeNextOccurrence(event.recurring_day);
    }

    if (!eventDateStr) return; // Skip events with no determinable date

    const date = parseLocalDate(eventDateStr);
    if (date >= today) {
      combined.push({
        id: `local-${event.id}`,
        title: event.title,
        description: event.description,
        date: eventDateStr,
        time: event.time || event.start_time,
        location: event.venue_name || event.venue || "Local Area",
        venue: event.venue_name,
        url: event.link,
        image_url: event.image_url,
        type: event.type,
        source_name: event.source_name,
        isNeighborhood: false,
        isRecurring: !!event.recurring,
        monthShort: date.toLocaleDateString("en-US", { month: "short" }),
        day: date.getDate(),
      });
    }
  });

  // Sort by date (soonest first)
  combined.sort(
    (a, b) =>
      parseLocalDate(a.date).getTime() - parseLocalDate(b.date).getTime()
  );

  // Return only first 6 upcoming events
  return combined.slice(0, 6);
});

const formatTime = (timeString: string) => {
  const [hours, minutes] = timeString.split(":");
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};

const fetchEvents = async () => {
  try {
    // Fetch neighborhood events and local events in parallel
    const [feed, localResponse] = await Promise.all([
      HoodApi.fetch_homepage_feed(),
      HoodApi.fetch_local_events({ limit: 10, scope: "local" }).catch((err) => {
        console.warn("Failed to fetch local events:", err);
        return {
          ok: false,
          data: [],
          meta: { total: 0, limit: 10, offset: 0 },
        };
      }),
    ]);

    neighborhoodEvents.value = feed.upcoming_events || [];

    // Store full event data for modal
    if (localResponse.ok && localResponse.data) {
      localEventsData.value = localResponse.data;
    }
  } catch (err) {
    console.error("Failed to fetch events:", err);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchEvents();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_router_link, {
            to: "/events",
            class: "text-sm text-accent-600 hover:text-accent-700 transition-colors"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "animate-pulse flex gap-3"
              }, _hoisted_9)
            }), 64))
          ]))
        : (_unref(events).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(events), (event) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: event.id,
                  onClick: ($event: any) => (selectedEvent.value = event),
                  class: "flex gap-3 p-4 hover:bg-primary-50 transition-colors cursor-pointer"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-12 h-12 rounded-lg flex flex-col items-center justify-center flex-shrink-0", 
            event.isNeighborhood
              ? 'bg-accent-100 text-accent-700'
              : 'bg-primary-100 text-primary-600'
          ])
                  }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(event.monthShort), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(event.day), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(event.title), 1),
                      (event.isNeighborhood)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, " HOA "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_18, [
                      (event.time)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(event.time) + " · ", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(event.location), 1)
                    ])
                  ]),
                  _hoisted_20
                ], 8, _hoisted_11))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24)),
      _hoisted_25
    ]),
    _createVNode(EventDetailModal, {
      event: selectedEvent.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (selectedEvent.value = null))
    }, null, 8, ["event"])
  ], 64))
}
}

})